import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function() {
  const sections = document.querySelectorAll('.about-section')

  sections.forEach(section => {
    const textWrapp = section.querySelector('.text-transform-wrapp')

    gsap.fromTo(
      section.querySelectorAll('.about-text-transform'),
      {
        x: '30%',
      },
      {
        x: '-30%',
        ease: 'none',
        scrollTrigger: {
          trigger: textWrapp,
          // markers: true,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 3,
        },
      }
    )
  })
}
